import { clone, cloneDeep } from 'lodash';

export default (obj, deep = true) => {
	return deep ? cloneDeep(obj) : clone(obj);
};
